export default __webpack_public_path__ + "static/RecklessNeue-Regular-c4ee78caa251b2f91b57153d5618dca9.woff";